var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('app-loading-screen',{on:{"selectCountry":_vm.setCountry}}),_c('app-header',{attrs:{"country":_vm.country}}),_c('app-content',{attrs:{"country":_vm.country,"promoteInstall":_vm.showInstallButton},on:{"installApp":_vm.installApp}}),_c('app-yellow-box',{attrs:{"country":_vm.country}}),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }